exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-carousel-v2-wrapper{display:flex;flex-direction:column;justify-content:center}.cap-carousel-v2-wrapper .switcher-icons{display:flex;margin-bottom:1.142rem;align-items:center;justify-content:space-between;max-width:220px;width:100%;align-self:center}.cap-carousel-v2-wrapper .switcher-icons .cap-icon-v2-chevron-left.disabled,.cap-carousel-v2-wrapper .switcher-icons .cap-icon-v2-chevron-right.disabled{cursor:not-allowed;color:#b3bac5}\n", ""]);

// exports
